<template>
  <router-view>
    <template v-slot:header>
      <div class="row myrow" @click="updateActionTime">
        <div class="col-xs-12 col-sm-12 col-md-12 mycol header">
          <Navbar></Navbar>
          <div
            class="pull-right mycol header-login"
            v-if="typeof currentUser !== 'undefined'"
          >
            <div class="info-block" v-show="showUserInfo">
              <div
                class="info-block__close"
                v-on:click="showUserInfo = false"
              ></div>
              <div class="info-block__title">Информация</div>
              <div class="info-block__text">
                <p style="text-align: center;">Уважаемый заявитель!</p>
                <p>
                  В настоящий момент возможна подача заявок в Фонд по
                  программам: "Проекты развития", "Лизинг", "Комплектующие
                  изделия", "Маркировка товаров", "Производительность труда",
                  "Улучшение экологии", "Приоритетные проекты",
                  "Автокомпоненты", и "Займы с регфондами". Ознакомиться со
                  стандартами по программам Фонда Вы можете скачав нашу
                  <a
                    target="_blank"
                    href="https://frprf.ru/download/prezentatsiya-programm-frp.pdf"
                    >презентацию</a
                  >, или перейдя по следующей ссылке
                  <a target="_blank" href="http://frprf.ru/zaymy/"
                    >http://frprf.ru/zaymy/</a
                  >
                </p>
              </div>
            </div>
            <div class="info-block" v-show="showDeclarerInfo">
              <div
                class="info-block__close"
                v-on:click="showDeclarerInfo = false"
              ></div>
              <div class="info-block__title"></div>
              <div class="info-block__text">
                <p style="text-align: center;">Уважаемый заявитель!</p>
                <template v-if="showIsNewRules">
                  <p>
                    Информируем Вас о том, что в соответствии с решением
                    Наблюдательного совета Фонда от 04.02.2022 г. с 14.02.2022
                    г. введены в действия дополнительные ограничения для подачи
                    заявок в Фонд развития промышленности:
                  </p>

                  <p>
                    1. По программам «Станкостроение», «Комплектующие изделия»,
                    «Комплектующие изделия (РФРП)» и «Приоритетные проекты»
                    компания-заявитель должна взять на себя обязательства по
                    подаче не менее одной заявки на регистрацию результатов
                    интеллектуальной деятельности (РИД) в ходе реализации
                    проекта.
                  </p>

                  <p>
                    2. В случае, если компания уже имеет действующий (-ие)
                    договор (-ы) займа (-ов) и/или заявку (-и) в работе Фонда по
                    двум и более проектам, подача заявки по программам «Лизинг»,
                    «Производительность труда» и «Производительность труда
                    (РФРП)» недоступна
                  </p>

                  <p>
                    3. Вышеприведенные ограничения не распространяются на
                    заявки, поданные в Фонд до 14.02.2022 включительно, за
                    исключением обязательства по подаче не менее одной заявки на
                    РИД по программе «Приоритетные проекты».
                  </p>
                </template>
                <template v-else>
                  <p>
                    Информируем Вас о том, что в соответствии с решением
                    Наблюдательного совета Фонда от 23.09.2021 г. с
                    01.10.2021&nbsp;г. введены в действия дополнительные
                    ограничения для подачи заявок в Фонд развития
                    промышленности:
                  </p>

                  <p>
                    1. По программе «Приоритетные проекты» компания-заявитель
                    должна взять на себя обязательства по подаче не менее одной
                    заявки на регистрацию результатов интеллектуальной
                    деятельности (РИД) в ходе реализации проекта.
                  </p>

                  <p>
                    2. Вышеприведенные ограничения не распространяются на
                    заявки, поданные в Фонд до 30.09.2021 включительно.
                  </p>
                </template>
              </div>
            </div>
            <div class="info-block" v-show="showLizingInfo">
              <div
                class="info-block__close"
                v-on:click="showLizingInfo = false"
              ></div>
              <div class="info-block__title">Изменения</div>
              <div class="info-block__text">
                <p style="text-align: center;">Уважаемый заявитель!</p>
                <template v-if="showIsNewRules">
                  <p>
                    Информируем Вас о том, что в соответствии с решением
                    Наблюдательного совета Фонда от 04.02.2022 г. с 14.02.2022
                    г. введены в действия дополнительные ограничения для подачи
                    заявок в Фонд развития промышленности:
                  </p>

                  <p>
                    1. По программам «Станкостроение», «Комплектующие изделия»,
                    «Комплектующие изделия (РФРП)» и «Приоритетные проекты»
                    компания-заявитель должна взять на себя обязательства по
                    подаче не менее одной заявки на регистрацию результатов
                    интеллектуальной деятельности (РИД) в ходе реализации
                    проекта.
                  </p>
                  <p>
                    2. В случае, если компания уже имеет действующий (-ие)
                    договор (-ы) займа (-ов) и/или заявку (-и) в работе Фонда по
                    двум и более проектам, подача заявки по программам «Лизинг»,
                    «Производительность труда» и «Производительность труда
                    (РФРП)» недоступна
                  </p>
                  <p>
                    3. Вышеприведенные ограничения не распространяются на
                    заявки, поданные в Фонд до 14.02.2022 включительно, за
                    исключением обязательства по подаче не менее одной заявки на
                    РИД по программе «Приоритетные проекты».
                  </p>
                </template>
                <template v-else>
                  <p>
                    Информируем Вас о том, что в соответствии с решением
                    Наблюдательного совета Фонда от 09.09.2019 г. с 01.10.2019
                    г. введены в действия дополнительные ограничения для подачи
                    заявок в Фонд развития промышленности:
                  </p>

                  <p>
                    1. По программе «Приоритетные проекты» компания-заявитель
                    должна взять на себя обязательства по подаче не менее одной
                    заявки на регистрацию результатов интеллектуальной
                    деятельности (РИД) в ходе реализации проекта.
                  </p>

                  <p>
                    2. Вышеприведенные ограничения не распространяются на
                    заявки, поданные в Фонд до 30.09.2019 включительно.
                  </p>
                </template>
              </div>
            </div>
            <a
              href="https://lkfrprf.bitrix24.site/"
              target="_blank"
              class="header-link-help-info"
              title="Справка"
            ></a>
            <ul class="l-menu test">
              <li>
                <a class="user-name" v-on:click="showUserMenu = !showUserMenu">
                  <span v-if="currentUser.TYPE_USER === 'declarer'">
                    {{ currentUser.NAME }}
                  </span>
                  <span v-else>{{ userRoleName }}</span>
                </a>
                <ul class="user-name-menu" v-show="showUserMenu">
                  <li v-show="roleChangeAvail">
                    <a
                      v-on:click="
                        showChangeRole = 1;
                        showUserMenu = !showUserMenu;
                      "
                      >Изменить роль</a
                    >
                  </li>
                  <li>
                    <a v-on:click="logout">Выйти</a>
                  </li>
                </ul>
              </li>
            </ul>

            <a
              v-show="
                false
                /*currentUser.TYPE_USER === 'declarer' &&
                  currentUser.ACTIVE_ROLE_CODE !== 'lizing'*/
              "
              v-on:click="showUserInfo = !showUserInfo"
              class="menu-info"
            >
              <span class="visible-lg">Информация</span>
              <span class="hidden-lg">&nbsp;</span>
            </a>
            <a
              v-show="
                false
                /*currentUser.TYPE_USER === 'declarer' &&
                  currentUser.ACTIVE_ROLE_CODE !== 'lizing'*/
              "
              v-on:click="showDeclarerInfo = !showDeclarerInfo"
              class="menu-info"
            >
              <span class="visible-lg">Изменения</span>
              <span class="hidden-lg">&nbsp;</span>
            </a>
            <a
              v-show="currentUser.ACTIVE_ROLE_CODE === 'lizing_'"
              v-on:click="showLizingInfo = !showLizingInfo"
              class="menu-info"
            >
              <span class="visible-lg">Изменения</span>
              <span class="hidden-lg">&nbsp;</span>
            </a>
          </div>
        </div>
      </div>
      <div
        class="modal fade in"
        v-bind:class="{ show: showChangeRole }"
        tabindex="-1"
        role="dialog"
      >
        <form v-on:submit.prevent="onChangeGroup">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  v-on:click="showChangeRole = false"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Изменить роль</h4>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label>Роль</label>
                  <select class="form-control" v-model="newActiveGroup">
                    <option
                      v-for="item in currentUser.GROUP_ID"
                      v-bind:key="item.ID"
                      v-bind:value="item.ID"
                      v-text="item.NAME"
                    ></option>
                  </select>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-default"
                  data-dismiss="modal"
                  v-on:click="showChangeRole = false"
                >
                  Отмена
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="newActiveGroup === currentUser.ACTIVE_ROLE"
                >
                  Изменить роль
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </form>
      </div>
      <!-- /.modal -->
    </template>

    <template v-slot:footer>
      <div class="footer footer-fix" style="z-index: 5">
        <div class="container-fluid mycontainer-fluid">
          <div class="myfooter">
            <div class="myfooter-frp"></div>
          </div>
        </div>
      </div>
    </template>
  </router-view>
</template>

<script>
import Navbar from "@/components/Navbar";
import $ from "jquery";
import { mapGetters } from "vuex";
import {
  OAUTH,
  LOGOUT,
  UPDATE_USER_ROLE,
  GET_USER_ROLE,
  REFRESH_TOKEN
} from "@/store/actions.type";
import { AUTH_URL, IS_DEV_MODE } from "@/common/config";
import { ProjectsService } from "@/common/api.service";
import jwtDecode from "jwt-decode";
import JwtService from "@/common/jwt.service";
import moment from "moment";

window.jQuery = $;
window.$ = $;

export default {
  name: "App",
  components: {
    Navbar: Navbar,
    SubHead: {
      template: ""
    }
  },
  computed: {
    userRoleName() {
      let roleName = "";
      this.currentUser.GROUP_ID.forEach(function(role) {
        if (role.ID === this.currentUser.ACTIVE_ROLE) {
          roleName = role.NAME;
        }
      }, this);
      return roleName;
    },
    ...mapGetters(["isAuthenticated", "currentUser"])
  },
  data() {
    return {
      roleChangeAvail: false,
      newActiveGroup: 0,
      showChangeRole: false,
      showUserInfo: false,
      showUserMenu: false,
      showDeclarerInfo: false,
      showLizingInfo: false,
      showIsNewRules: false
    };
  },
  created() {
    setTimeout(
      () => document.addEventListener("click", this.updateActionTime),
      0
    );
    setInterval(this.updateToken, 1000);

    this.showIsNewRules =
      new Date() > new Date("2022-02-13 23:59") ? true : false;
  },
  mounted() {
    JwtService.saveLastAction(new Date().getTime());
    if (typeof this.$route.query.access_token != "undefined") {
      this.$store.dispatch(OAUTH, this.$route.query.access_token).then(() => {
        this.newActiveGroup = this.currentUser.ACTIVE_ROLE;
        if (
          typeof this.currentUser.GROUP_ID !== "undefined" &&
          this.currentUser.GROUP_ID.length > 1
        ) {
          this.roleChangeAvail = true;
        }
        if (this.currentUser.REDIRECT) {
          window.location.href = this.currentUser.REDIRECT;
          return;
        }
        if (this.currentUser.TYPE_USER === "manager") {
          ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
            if (data.START_PAGE === "REESTR_EXPERTISE") {
              this.$router.push({ name: "Expertise" });
            } else {
              if (this.newActiveGroup == 36 || this.newActiveGroup == 37) {
                this.$router.push({ name: "Conference" });
              } else if (this.newActiveGroup == 38) {
                this.$router.push({ name: "Experts" });
              } else {
                this.$router.push({ name: "Projects" });
              }
            }
          }, this);
        } else {
          this.$router.push({ name: "Projects" });
        }
      });
    } else if (!this.isAuthenticated && this.$route.name !== "Auth") {
      if (IS_DEV_MODE) {
        this.$router.push({
          name: "Auth",
          query: { redirect: window.location.pathname + window.location.search }
        });
      } else {
        window.location.href =
          AUTH_URL +
          "?redirect=" +
          window.location.pathname +
          window.location.search;
      }
    }

    if (typeof this.currentUser !== "undefined") {
      this.newActiveGroup = this.currentUser.ACTIVE_ROLE;
      if (
        typeof this.currentUser.GROUP_ID !== "undefined" &&
        this.currentUser.GROUP_ID.length > 1
      ) {
        this.roleChangeAvail = true;
      }
      if (!this.$route.query.access_token) {
        let exp = jwtDecode(JwtService.getToken());
        let expDate = new Date();
        expDate.setTime(exp.exp * 1000);
        let date = new Date();
        if (
          expDate.getTime() <
          moment(date)
            .toDate()
            .getTime()
        ) {
          //alert("Будет осуществлен выход из системы по причине не активности!");
          this.logout();
        }
      }
    }
  },
  methods: {
    updateActionTime() {
      JwtService.saveLastAction(new Date().getTime());
    },
    updateToken() {
      if (this.$route.query.access_token) {
        //alert(this.$route.query.access_token);
        return;
      }
      if (JwtService.getToken() && this.currentUser) {
        let exp = jwtDecode(JwtService.getToken());
        let expDate = new Date();
        expDate.setTime(exp.exp * 1000);
        let date = new Date();

        if (
          JwtService.getLastAction() <
          moment(date)
            .add(-180, "m")
            .toDate()
            .getTime()
        ) {
          alert("Будет осуществлен выход из системы по причине не активности!");
          this.logout();
        }
        if (
          expDate.getTime() <
          moment(date)
            .add(10, "m")
            .toDate()
            .getTime()
        ) {
          this.$store.dispatch(REFRESH_TOKEN);
        }
      }
    },
    onChangeGroup() {
      this.$store.dispatch(UPDATE_USER_ROLE, this.newActiveGroup).then(() => {
        this.$store.dispatch(GET_USER_ROLE).then(() => {
          ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
            if (data.START_PAGE === "REESTR_EXPERTISE") {
              this.$router.push({ name: "Expertise" });
              window.location.reload();
            } else {
              if (this.newActiveGroup == 36 || this.newActiveGroup == 37) {
                this.$router.push({ name: "Conference" });
              } else if (this.newActiveGroup == 38) {
                this.$router.push({ name: "Experts" });
              } else {
                this.$router.push({ name: "Projects" });
              }
              window.location.reload();
            }
          }, this);
        });
      });
    },
    logout() {
      if (IS_DEV_MODE) {
        this.$store
          .dispatch(LOGOUT, this.$route.query.access_token)
          .then(() => this.$router.push({ name: "Auth" }));
      } else {
        this.$store
          .dispatch(LOGOUT, this.$route.query.access_token)
          .then(() => {
            window.location.href = AUTH_URL + "auth/logout.php";
          });
      }
    }
  }
};
</script>

<style></style>
